import { render, staticRenderFns } from "./ThrowSettings.vue?vue&type=template&id=4cf88314&scoped=true"
import script from "./ThrowSettings.vue?vue&type=script&lang=js"
export * from "./ThrowSettings.vue?vue&type=script&lang=js"
import style0 from "./ThrowSettings.vue?vue&type=style&index=0&id=4cf88314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf88314",
  null
  
)

export default component.exports